import queryString from "query-string"

const defaultOptions = {
  mode: "cors",
  credentials: "include",
}

export async function get(url, options = {}) {
  const request = new Request(url, {
    ...options,
    method: "GET",
    mode: "cors",
    credentials: "include",
  })
  return fetch(request)
}

export async function postJSON(url, options = { body: {} }) {
  const mergedOptions = {
    ...defaultOptions,
    headers: {
      ...defaultOptions.headers,
      "Content-type": "application/json",
    },
    ...options,
    body: JSON.stringify(options.body),
  }

  return fetch(url, {
    method: "POST",
    ...mergedOptions,
  })
}

export async function postForm(url, options = { body: {} }, token = null) {
  const mergedOptions = {
    ...defaultOptions,
    ...options,
    body: queryString.stringify(options.body),
  }

  return fetch(url, {
    method: "POST",
    ...mergedOptions,
    headers: {
      ...mergedOptions.headers,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
}
